export const capitalize = (string) =>
	string.charAt(0).toUpperCase() + string.substr(1);

export const getNumericDeclension = (number, wordVariants) => {
	const lastDigit = number % 10;
	const lastDecade = number % 100;

	let suffixType = 'many';

	if (lastDecade > 10 && lastDecade < 20) {
		suffixType = 'many';
	} else if (lastDigit === 1) {
		suffixType = 'single';
	} else if (lastDigit > 1 && lastDigit < 5) {
		suffixType = 'some';
	}

	return wordVariants[suffixType];
};
